import type { FaireProductEntity } from "../../entity_types/product";

export const p_wwpg9zkt3x: FaireProductEntity = {
  token: "p_wwpg9zkt3x",
  type: "product",
  name: "M7351-SW CALIFORNIA",
  brandToken: "b_7t768kwdvz",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/b08418a33e333f754a52ed0a22c61409b8aea82baa6a1aaa9b9d0510c72dae3c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a0b66c5aca8fcadeb483268821cf2b480055856e974159a21f7f2f1ff4bd63ba.jpeg",
    "https://cdn.faire.com/fastly/6d3eb06036dec1281a4bc5413f1c7704e2e7e9bad932df84313dfe8ba3665dda.jpeg",
    "https://cdn.faire.com/fastly/14936a5135c60d2a507cc16fab47b5e0dee41194af026d60b54ca43a289b9154.jpeg",
    "https://cdn.faire.com/fastly/48b8baec7e99ee3c06b5158d0dc016ea6f64f9622cc733afc1f27d1ad87f8c1e.jpeg",
  ],
  priceDollars: 23.49,
  description:
    "This unisex tee is made of very soft cotton. The double stitching on the neckline and sleeves add more durability to what is sure to be a favorite!\nFeatures: Mid-weight Fleece \nFabrication: 80% Cotton, 20% Poly Ring-Spun Yarn 7.8 oz.\nPrinted in the USA. \n-S-3XL AVAILABLE\n-Other colors are also available\n-Please write it down in the memo when you make a purchase .",
  tags: [],
  msrpDollars: 46.97,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:49.715Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
